
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/xinpin/[id]",
      function () {
        return require("private-next-pages/xinpin/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/xinpin/[id]"])
      });
    }
  